import ApplicationController from './application_controller';

export default class extends ApplicationController {
  value() {
    const element = document.getElementById('time-delay-radio-options');
    if (this.element.value === 'Add a delay before each electronic claim is submitted.') {
      if (element.classList.contains('d-none')) {
        element.classList.remove('d-none');
      }
    } else {
      element.classList.add('d-none');
    }
  }
}
